import React from 'react';
import './home.scss';

// ResponsiveBox Importe
import ResponsiveBox, { 
    Row, 
    Col, 
    Item as ResponsiveBoxItem,     // ← Alias!
    Location 
} from "devextreme-react/responsive-box";

import SelectBox from 'devextreme-react/select-box';
import TabPanel, { Item as TabPanelItem } from 'devextreme-react/tab-panel';  // ← Alias!
import DataGrid, { Column,
    Selection,
    Toolbar,
    Item
 } from 'devextreme-react/data-grid';
 import LoadPanel from 'devextreme-react/load-panel';
 import CustomStore from 'devextreme/data/custom_store';
 import { confirm } from 'devextreme/ui/dialog';

import defaultUser from '../../utils/default-user';
import deMessages from "devextreme/localization/messages/de.json";
import { locale, loadMessages } from "devextreme/localization";

function LinkCell(props) {
    return (
        <a target="_blank" rel="noopener noreferrer" href={props.data.dgsLink}>
            {props.data.linkTitle}
        </a>
    );
}

class Home extends React.Component { 
    constructor(props) {
        super(props);
        loadMessages(deMessages);
        locale(navigator.language);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.onValueChanged = this.onValueChanged.bind(this);

        this.documentGrid = React.createRef();
        this.oiGrid = React.createRef();
        this.downloadAllPdfs = this.downloadAllPdfs.bind(this);

        this.state = {
            client: defaultUser.client,
            isLoading: false,
        };

        this.oiStore = new CustomStore({
            key: 'moiId',
            load: () => {
                const url = `https://dgs.it-tn.de/api/getOiLinks.php?clientId=${this.state.client}`;
                return fetch(url)
                    .then(response => response.json())
                    .catch(err => {
                        console.error(err);
                        return [];
                    });
            }
        });

        this.selectedCount = 0;
        this.downloadButtonRef = React.createRef();
    }

    oiGrid = React.createRef();

    onSelectionChanged(e) {
        this.selectedCount = e.selectedRowKeys ? e.selectedRowKeys.length : 0;
        const btn = document.getElementById("downloadButton");

        if (btn) {
            btn.disabled = this.selectedCount === 0;
        }
    }

    onValueChanged(e) {
        const newClientId = e.value;
        defaultUser.client = newClientId;
        
        this.setState({
            client: newClientId
        });
    }

    onGridReady = () => {
        const btn = document.getElementById("downloadButton");
        console.log("ready");
        if (btn) {
            btn.disabled = this.selectedCount === 0;
        }
    }

    async downloadAllPdfs() {
            const ref = this.oiGrid.current;
    
            if (!ref) {
                return;
            }
            const instance = ref.instance ? ref.instance() : ref.getInstance?.();
    
            if (!instance || typeof instance.getSelectedRowKeys !== 'function') {
                return;
            }
    
            const selectedKeys = instance.getSelectedRowKeys();
    
            if (!selectedKeys || selectedKeys.length === 0) {
                return;
            }
    
            const result = await confirm(
                `<p><strong>${selectedKeys.length} Betriebsanweisung(en) herunterladen?</strong></p>
                <p>Es wird eine ZIP-Datei mit den ausgewählten Betriebsanweisungen erstellt.</p>
                <p style="font-size:0.80em; margin-top:10px;">
                    Je nach Anzahl der ausgewählten Betriebsanweisungen und Größe der PDFs kann dieser Vorgang<br/> 
                    systemseitig länger dauern oder in Einzelfällen nicht erfolgreich abgeschlossen werden.
                </p>`,
                'PDF-Download bestätigen'
            );
    
            if (!result) {
                return; 
            }
            // Loading aktivieren
            this.setState({ isLoading: true });
    
            try {
                const response = await fetch('https://dgs.it-tn.de/api/downloadOiPdf.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ oiIds: selectedKeys })
                });
    
                if (!response.ok) {
                    alert('Fehler beim Erstellen der ZIP-Datei.');
                    return;
                }
    
                // Prüfen, ob JSON-Fehlermeldung kommt
                const contentType = response.headers.get('content-type');
                if (contentType && contentType.includes('application/json')) {
                    const errorData = await response.json();
                    alert(errorData.message || 'Es konnten keine PDF-Berichte heruntergeladen werden.');
                    return;
                }
    
                // ZIP herunterladen
                const blob = await response.blob();
                const downloadUrl = window.URL.createObjectURL(blob);
                
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = `Betriebsanweisungen_PDFs_${new Date().toISOString().slice(0, 10)}.zip`;
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(downloadUrl);
    
            } catch (error) {
                console.error(error);
                alert('Download fehlgeschlagen. Bitte versuche es später erneut.');
            } finally {
                // Loading immer deaktivieren (auch bei Fehler)
                this.setState({ isLoading: false });
            }
        }

    render() {
        const { client, isLoading } = this.state;
        const jsonUrl = `https://dgs.it-tn.de/api/getClients.php?clientId=${client}&user=${defaultUser.email}`;
        const jsonDocs = `https://dgs.it-tn.de/api/getDocumentLinks.php?clientId=${client}`;
        const jsonOi = `https://dgs.it-tn.de/api/getOiLinks.php?clientId=${client}`;

        return (
            <React.Fragment>
                <h2 className="content-block">Start</h2>
                <div className="content-block">
                    <div className="dx-card responsive-paddings">
                        <div id="DGSLogo">
                            <img src="https://dgs.it-tn.de/images/1-1-e1728484243919.jpg" alt="" width="500" height="130"/>
                        </div>

                        <p>Vielen Dank für die Nutzung unserer Kundenplattform.</p>
                        <p>
                            Sie haben hier die Möglichkeit, sich über geplante und durchgeführte Audits in Ihren Standorten zu informieren.<br />
                            Weiterhin finden Sie Informationen im Zusammenhang mit durchgeführten Audits bei den einzelnen Standorten.<br /><br />
                            Im unteren Teil dieser Seite sind relevante Dokumentationen für Ihr Unternehmen verfügbar.
                        </p>
                        <p>
                            Melden Sie sich bei Fragen, Anregungen oder anderen Themen gerne über die Ihnen bekannten Kontaktwege.
                        </p>
                    </div>

                    <ResponsiveBox singleColumnScreen="sm" className="dx-card responsive-paddings">
                        <Col ratio={2} />
                        <Col ratio={1} />
                        <Row ratio={1} />

                        <ResponsiveBoxItem>   {/* ← ResponsiveBox Item */}
                            <Location row={0} col={0} />
                            <div style={{ height: "100%" }}>
                            <TabPanel
                                height="calc(100vh - 750px)"
                                animationEnabled={true}
                                swipeEnabled={false}
                            >
                                <TabPanelItem title="Dokumentationen">
                                    <DataGrid
                                        ref={this.documentGrid}
                                        key={`docs-${client}`} 
                                        dataSource={jsonDocs}
                                        showBorders={true}
                                        showColumnLines={true}
                                        columnAutoWidth={true}
                                        allowColumnResizing={true}
                                        height="100%"
                                        showRowLines={true}
                                        wordWrapEnabled={true}
                                        paging={{ enabled: false }}
                                        scrolling={{ mode: "infinite" }}
                                    >
                                        <Column dataField="dgsLink" caption="Dokument" cellRender={LinkCell} width={280} allowHiding={false} />
                                        <Column dataField="linkTitle" caption=" " visible={false} />
                                        <Column dataField="linkRemark" caption="Bemerkung" allowHiding={false} />
                                    </DataGrid>
                                </TabPanelItem>

                                <TabPanelItem title="Betriebsanweisungen">
                                    <DataGrid
                                        ref={this.oiGrid}
                                        //key={`oi-${client}`}
                                        dataSource={jsonOi}
                                        showBorders={true}
                                        showColumnLines={true}
                                        columnAutoWidth={true}
                                        allowColumnResizing={true}
                                        height="100%"
                                        showRowLines={true}
                                        wordWrapEnabled={true}
                                        paging={{ enabled: false }}
                                        scrolling={{ mode: "infinite" }}
                                        onSelectionChanged={this.onSelectionChanged}
                                        onContentReady={this.onGridReady}
                                    >
                                        <Selection mode="multiple" />

                                        <Toolbar>
                                            <Item location="after">
                                                <button
                                                    id="downloadButton"
                                                    ref={this.downloadButtonRef}
                                                    onClick={this.downloadAllPdfs}
                                                    className="dx-button dx-button-success dx-button-mode-contained"
                                                    disabled={false}
                                                    style={{ marginRight: 5 }}
                                                >
                                                    {this.state.isLoading 
                                                        ? 'ZIP wird erstellt...' 
                                                        : 'Ausgewählte Betriebsanweisung(en) herunterladen'
                                                    }
                                                </button>
                                            </Item>
                                        </Toolbar>

                                        <Column dataField="moiId" caption="#" visible={true} />
                                        <Column dataField="dgsLink" caption="Bezeichnung" cellRender={LinkCell} width={280} allowHiding={false} />
                                        <Column dataField="oitDescription" caption="Arbeitsbereich" visible={true} />
                                        <Column dataField="linkTitle" caption=" " visible={false} />
                                        <Column dataField="linkTag" caption="Kennung" allowHiding={false} />
                                        <Column dataField="moiCd" caption="Erstellungsdatum" visible={true} />
                                    </DataGrid>
                                    <LoadPanel
                                        visible={this.state.isLoading}
                                        showIndicator={true}
                                        shading={true}
                                        shadingColor="rgba(0,0,0,0.4)"
                                        message="ZIP-Datei wird erstellt..."
                                        position={{ of: 'body' }}
                                    />
                                </TabPanelItem>
                            </TabPanel>
                            </div>
                        </ResponsiveBoxItem>

                        {defaultUser.userGroup === "dgs" && (
                            <ResponsiveBoxItem>
                                <Location row={0} col={1} />
                                <div>
                                    <div className="dx-fieldset">
                                        <div className="dx-fieldset-header">Mandantenauswahl</div>
                                        <div className="dx-field">
                                            <div className="dx-field-value">
                                                <SelectBox
                                                    dataSource={jsonUrl}
                                                    displayExpr="msName"
                                                    valueExpr="msId"
                                                    value={client} 
                                                    width="100%"
                                                    placeholder="Mandantenauswahl"
                                                    onValueChanged={this.onValueChanged}
                                                    //defaultValue={defaultUser.client}
                                                    wrapItemText={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ResponsiveBoxItem>
                        )}
                    </ResponsiveBox>
                </div>
            </React.Fragment>
        );
    }
}

export default Home;